import { render, staticRenderFns } from "./SaleSendCloudParcels.vue?vue&type=template&id=0b24b3f6"
import script from "./SaleSendCloudParcels.vue?vue&type=script&lang=ts"
export * from "./SaleSendCloudParcels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b24b3f6')) {
      api.createRecord('0b24b3f6', component.options)
    } else {
      api.reload('0b24b3f6', component.options)
    }
    module.hot.accept("./SaleSendCloudParcels.vue?vue&type=template&id=0b24b3f6", function () {
      api.rerender('0b24b3f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sendcloud/SaleSendCloudParcels.vue"
export default component.exports